import { Avatar, Link, Stack, Typography } from "@mui/material";
import { CPLogo } from "@warden-ui/common-components";

interface CardContentSuccessProps {
  teamDomain: string;
  teamLogoUrl?: string;
  onClick?: () => void;
}

export const CardContentSuccess = ({
  teamDomain,
  teamLogoUrl,
  ...props
}: CardContentSuccessProps) => {
  const showLogo = teamLogoUrl && teamLogoUrl.length > 0;
  return (
    <Stack className="cp-resp-sign-card d-flex-column-center">
      <CPLogo />

      {showLogo && <Avatar
        className="mt-1"
        variant="rounded"
        src={teamLogoUrl}
        sx={{ width: 80, height: 60}}
      />}

      <span className="cp-hint">
        {teamDomain}
      </span>

      <Typography className="mt-4" style={{ fontSize: 24, fontWeight: 500 }}>
        Launching CupixConnect
      </Typography>

      <span className="cp-hint pt-1" style={{ fontSize: 14 }}>
        Click <b>"Open CupixConnect"</b> to launch the desktop app.
      </span>

      <Stack 
        spacing={0.5}
        direction="row"
        sx={{ mt: 3 }}
      >

        <Typography style={{ fontSize: 14 }}>
          Nothing happend?
        </Typography>

        <Link
          component="button"
          underline="none"
          onClick={props.onClick}
          sx={{ fontSize: 14 }}
        >
        Click here
        </Link>

        <Typography style={{ fontSize: 14 }}>
          to try again.
        </Typography>

      </Stack>
    </Stack>
  );
};
